import moment from 'moment';
import AccountsModel from '../models/accounts.model';

let storeContent = utils.generateStore({
	conversations: [],
	messages: [],
	accountTransactions: [],
	showViewAccount: false,
	text: '',
	message_scroll: null,
	selectedConversation: null,
	AccountsModel,
	loading: false,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchConversations(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'chat',
						action: 'my_conversations',
						data: {
							chat_user_id:
								ctx.getters.chat_id ||
								(await $session.get('chat_id')),
						},
					},
					'/client',
				);

				if (res.result.conversations.length > 0) {
					let conversations = res.result.conversations.map(
						(conversation) => {
							let selected = false;

							// if(ctx.getters.selected_chat_user && ctx.getters.selected_chat_user === conversation){

							// }
							return {
								...conversation,
								last_message:
									'We are eager to get a reply from you with regards to the purchase made on 12th Jan 2015',
								time: 'Fri, 27 Mar 2020 11:12:43 GMT',
								count: 1,
								profile: '/img/avatars/2.png',
								selected,
							};
						},
					);

					let chats = await ctx.dispatch(
						'fetchConversationMessages',
						{ conversation: conversations[0] },
					);
					if (chats) {
						conversations[0].selected = true;
						conversations[0].last_message =
							chats[chats.length - 1].text;
						conversations[0].count = chats.length;
						ctx.commit('selectedConversation', conversations[0]);
					}

					ctx.commit('conversations', conversations);
				}

				await ctx.dispatch('scrollToBottom', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async changeSelectedConversation(ctx, conversation) {
			try {
				Event.$emit('loader:show', true);
				for (let i = 0; i < ctx.getters.conversations.length; i++) {
					const c = ctx.getters.conversations[i];
					ctx.getters.conversations[i].selected = false;

					if (
						c.chat_conversations.conversation_id ===
						conversation.chat_conversations.conversation_id
					) {
						ctx.getters.conversations[i].selected = true;
					}
				}
				ctx.commit('conversations', ctx.getters.conversations);
				ctx.commit('selectedConversation', conversation);

				await ctx.dispatch('fetchConversationMessages', {
					conversation,
				});
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async scrollToBottom(ctx, is_main) {
			try {
				let obj = document.querySelector('#message-scroll');
				if (is_main) {
					ctx.getters.message_scroll.scrollToY(obj.scrollHeight);
				} else {
					obj.scrollTop = obj.scrollHeight;
				}
			} catch (err) {
				throw err;
			}
		},
		async destroyEvents(ctx) {
			try {
				ctx.getters.socket.off('chat:message');
			} catch (err) {
				throw err;
			}
		},
		async listenForMessage(ctx) {
			try {
				ctx.getters.socket.on('chat:message', async (data) => {
					let messages = ctx.getters.messages;

					messages[0].messages.push({
						text: data.conversation.conversation_text,
						time: moment(data.conversation_date).format('HH:mm A'),
						isOwner: false,
					});
					ctx.commit('messages', messages);
					await ctx.dispatch('scrollToBottom');
				});
			} catch (err) {
				throw err;
			}
		},
		async sendMessage(ctx) {
			try {
				if (ctx.getters.text) {
					let messages = ctx.getters.messages;

					messages[0].messages.push({
						text: ctx.getters.text,
						time: '12:46 PM',
						isOwner: true,
					});

					// Push to conversations
					ctx.getters.socket.emit('chat:message', {
						conversation_id:
							ctx.getters.selectedConversation.chat_conversations
								.conversation_id,
						conversation: {
							conversation_type: 'text',
							conversation_text: ctx.getters.text,
							conversation_path: '',
							from_chat_user_id:
								ctx.getters.chat_id ||
								(await $session.get('chat_id')),
							to_chat_user_id: Number(
								ctx.getters.selectedConversation
									.chat_conversations
									.chat_user_identification,
							),
							// to_chat_user_id: 0,
						},
					});

					ctx.commit('messages', messages);
					ctx.commit('text', '');
					console.log(ctx.getters.text);
					await ctx.dispatch('scrollToBottom');
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchConversationMessages(ctx, payload) {
			try {
				ctx.commit('messages', [{ text: 'Recent', messages: [] }]);
				let chats = null;
				let res = await api.fetchEndpointSecure(
					{
						resource: 'chat',
						action: 'chat_conversations',
						data: {
							conversation_id:
								payload.conversation.chat_conversations
									.conversation_id,
						},
					},
					'/client',
				);

				let chat_id =
					ctx.getters.chat_id || (await $session.get('chat_id'));
				if (res.result.chats && res.result.chats.length > 0) {
					chats = res.result.chats.map((chat) => {
						return {
							text: chat.conversation.conversation_text,
							time: '12:46 PM',
							isOwner:
								chat.conversation.from_chat_user_id === chat_id,
						};
					});

					ctx.commit('messages', [
						{ text: 'Recent', messages: chats },
					]);
				}

				return chats;
			} catch (err) {
				throw err;
			}
		},
	},
};
